import { types, Instance } from 'mobx-state-tree';
import { set, toJS } from 'mobx';
import { IApiConfigurationStyle } from '../../../../types/Configuration';

export const StyleCustomizations = types
  .model({
    theme: types.optional(types.string, ''),
    primaryFont: types.optional(types.string, ''),
    mainBackgroundColor: types.optional(types.string, ''),
    mainAccentColor: types.optional(types.string, ''),
    mainLinkColor: types.optional(types.string, ''),
    mainSectionHeaderColor: types.optional(types.string, ''),
    formBackgroundColor: types.optional(types.string, ''),
    formAccentColor: types.optional(types.string, ''),
    formFieldBackground: types.optional(types.string, ''),
    formFieldText: types.optional(types.string, ''),
    cartSummaryBackgroundColor: types.optional(types.string, ''),
    cartSummaryAccentColor: types.optional(types.string, ''),
    orderSummaryBackgroundColor: types.optional(types.string, ''),
    orderSummaryAccentColor: types.optional(types.string, ''),
    primaryButtonBackground: types.optional(types.string, ''),
    buttonBackgroundColor: types.optional(types.string, ''),
    buttonTextColor: types.optional(types.string, ''),
  })
  .actions(self => {
    const setStyles = (styleList: IApiConfigurationStyle[]): void => {
      styleList.forEach(item => {
        set(self, {
          [item.key.replaceAll('style.', '')]: item.value,
        });
      });
    };
    const getStyles = (): IApiConfigurationStyle[] => {
      const selfJs = toJS(self);
      type SK = keyof typeof selfJs;
      return Object.keys(selfJs)
        .map(key => {
          return { key: `style.${key}`, value: selfJs[key as SK] };
        })
        .filter(item => Boolean(item.value));
    };
    return {
      setStyles,
      getStyles,
    };
  });
export interface IStyleCustomizations
  extends Instance<typeof StyleCustomizations> {}
